import { persistStore } from 'redux-persist';

const { default: s } = process.env.NODE_ENV === 'production' ? require('./storeProd') : require('./storeDev');

export const store = s();
export const persistor = persistStore(store);
